
import AvailabilityGeneral from './AvailabilityGeneral'
import AvailabilityLine from './AvailabilityLine'
import AvailabilityNode from './AvailabilityNode'
//import AvailabilityResponse from './AvailabilityResponse'
import AvailabilityStep from './AvailabilityStep'
import AvailabilityNodeDetail from './AvailabilityNodeDetail'
import AvailabilityDowntimeGlobal from './AvailabilityDowntimeGlobal'
import AvailabilityDowntime from './AvailabilityDowntime'
import AvailabilityConsolidated from './AvailabilityConsolidated';
import AvailabilityConsolidatedPerStep from './AvailabilityConsolidatedPerStep';
import TableAvailability from './TableAvailability'
import { TableExcelExportButton } from '../../../../components/TableExcelExportButton'
import { buildObjectiveTitle } from '../../../../utils/fns/build-excel-rows'
import {getMonitorsList} from '../../../../services/getMonitorsList'

import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';

import Period from '../../../../helpers/Period';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';

// Material components
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';

import RefreshIcon from '@material-ui/icons/Refresh';

import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import InfoIcon from '@material-ui/icons/Info';
import Switch from '@material-ui/core/Switch';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import UpdateIcon from '@material-ui/icons/Update';
import Avatar from '@material-ui/core/Avatar';
import HelpIcon from '@material-ui/icons/Help';

import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Tooltip from '@material-ui/core/Tooltip';

import PerfectScrollbar from 'react-perfect-scrollbar';
import Highcharts from 'highcharts/highstock'
// Palette
import palette from 'theme/palette';

// Component styles
import styles from './styles';

import moment from 'moment-timezone'
import 'moment/locale/es'
import { getDefaultPeriod } from '../../../../utils/local-storage/select-periodo'
import { NewGraphAvailabilityNode } from './AvailabilityNode/NewGraphAvailibilityNode'
import { useTranslation, withTranslation } from 'react-i18next'
import { AvailabilityDowntimeGlobalWithError } from './AvailabilityDowntimeGlobalWithError'
import { Box, FormControlLabel } from '@material-ui/core'
moment.locale('es')

const REFRESH_TIME = 300000

class Availability extends Component {
    constructor(props) {
        super(props);
        var statePeriod={}
        var periodical=false
        var periodicalView=props.periodicalView
        var scheduleType=0
        var scheduleName = props.t('text.all-schedules')
        var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
        var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'day').format("YYYY-MM-DD h:mm:ss"))
        statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
        var step=this.props.location.state.fromObjective.Pasos[0].id_paso
        var isStep= this.props.typeGraph === 6 ? true : false
        // var nameStep=null

        var nameStep=this.props.location.state.fromObjective.Pasos[0].nombre_paso

        if(props.periodical===true || props.online==true){
        // if(props.periodical===true){
            var year=String(props.year)
            var month=String(props.indexMonth+1)
            const begin=(moment(year+'-'+month+'-01')._d)
            const final= (moment(begin).endOf('month')._d)
            var schedules=JSON.parse(sessionStorage.getItem("horarios"))
            periodical=true
            statePeriod={startDate: begin,endDate: final,key: "selection"}
            scheduleType=props.schedule
            scheduleName=(schedules.filter(i=>i.horario_id==props.schedule))[0]["nombre"]
            if(props.isStep===true){
                //step=this.props.indexStep
                isStep=true
                // nameStep=(this.props.steps.filter(i=>i.id_paso===this.props.indexStep)[0]["nombre_paso"])
            }            
            if (props.globalPeriodValue === "custom") {
                statePeriod = props.globalStatePeriod
            }
        }

        if(props.period === 'c' && props.AvailabilityCon === 'AvailabilityCon') {
            var date = props.statePeriodAvailability
            const begin=(moment(date.startDate)._d)
            const final= (moment(date.endDate)._d)
            statePeriod ={startDate: begin,endDate: final,key: "selection"}
            scheduleType=props.schedule
            if(props.isStep===true){
                step=this.props.indexStep
                isStep=true
                // nameStep=(this.props.steps.filter(i=>i.id_paso===this.props.indexStep)[0]["nombre_paso"])
            }
        }

        if(props.period === 'c' && props.AvailabilityTotal === 'AvailabilityTotal') {
            var date = props.statePeriodAvailaTotal
            const begin=(moment(date.startDate)._d)
            const final= (moment(date.endDate)._d)
            statePeriod ={startDate: begin,endDate: final,key: "selection"}
            scheduleType=props.schedule
            if(props.isStep===true){
                step=this.props.indexStep
                isStep=true
                // nameStep=(this.props.steps.filter(i=>i.id_paso===this.props.indexStep)[0]["nombre_paso"])
            }
        }

        if(props.period === 'c' && props.AvailabilityTable === 'AvailabilityTable') {
            var date = props.statePeriodAvailaTable
            const begin=(moment(date.startDate)._d)
            const final= (moment(date.endDate)._d)
            statePeriod ={startDate: begin,endDate: final,key: "selection"}
            scheduleType=props.schedule
            if(props.isStep===true){
                step=this.props.indexStep
                isStep=true
                // nameStep=(this.props.steps.filter(i=>i.id_paso===this.props.indexStep)[0]["nombre_paso"])
            }
        }
        //console.log(statePeriod)
        
        this.handleDowntimeGeneralClick = this.handleDowntimeGeneralClick.bind(this);
        this.handleDowntimeStepGeneralClick = this.handleDowntimeStepGeneralClick.bind(this);
        this.handleAvailabilityGeneralClick = this.handleAvailabilityGeneralClick.bind(this);
        this.handleAvailabilityLineClick = this.handleAvailabilityLineClick.bind(this);
        this.handleAvailabilityNodeClick = this.handleAvailabilityNodeClick.bind(this);
        //this.handleAvailabilityResponseClick = this.handleAvailabilityResponseClick.bind(this);
        this.handleAvailabilityStepClick = this.handleAvailabilityStepClick.bind(this);
        this.handleAvailabilityNodeDetailClick = this.handleAvailabilityNodeDetailClick.bind(this);
        this.handleAvailabilityConsolidatedClick = this.handleAvailabilityConsolidatedClick.bind(this);
        this.handleAvailabilityConsolidatedPerStepClick = this.handleAvailabilityConsolidatedPerStepClick.bind(this);

        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.handleNextStepClick = this.handleNextStepClick.bind(this);
        this.handleNextNodeClick = this.handleNextNodeClick.bind(this);
        this.handleInfo = this.handleInfo.bind(this);
        this.handleFirstInfo = this.handleFirstInfo.bind(this);
        this.handleDateMoment = this.handleDateMoment.bind(this);
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        this.state = {
            typeGraph: this.props.typeGraph,
            period: this.props.period,
            step: step,
            steps: this.props.location.state.fromObjective.Pasos,
            node: 0,
            isForStep: isStep,
            isForNode: false,
            nameStep: nameStep,
            namePeriod: null,
            x2: null,
            x: null,
            y: null,
            isLastEvent: false,
            objetive: this.props.match.params.objetivo_id,
            statePeriod: statePeriod,
            isStatePeriod: false,
            responseTimeGraphEl: null,
            periodEl: null,
            extendEl: null,
            nameGraph: [' Total Consolidada', ' Uptime Real', ' Consolidada Por ISP', ' ', ' Distribución Porcentual', ' Consolidada Por Pasos', 
            ' Downtime Global Por Paso', ' Consolidada', ' Consolidada Por Paso', ' Resumen', ' Downtime Global'],
            namePeriodPorlet: ['Última Hora', 'Último Día', 'Última Semana', 'Custom', 'Últimas 3 Horas', 'Últimos 3 Días'],
            typePeriod: this.props.typePeriod,
            nameNodo: t('availability.name-nodo'),
            nameSelectStep: "Seleccione Paso",
            isStepDowntime: this.props.isStepDowntime,
            settingsEl: null,
            isRefresh: false,
            isInfo: null,
            checkedA: this.props.automaticUpdate,
            date: new Date(),
            dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a")),
            isOneHour: true,
            periodical:periodical,
            schedule:scheduleType,
            scheduleName:scheduleName,
            detalleGraph:['  Corresponde a la disponibilidad Consolidada del objetivo durante el período y horario seleccionado', 
                        '  Corresponde al Uptime Consolidado del objetivo durante el período y horario seleccionado',
                        '  Corresponde a los estados visualizados por cada ISP. Durante el período y horario seleccionado',
                        '',
                        '  Corresponde a los estados Consolidados por cada paso. Durante el período y horario seleccionado. La primera carga corresponde a global',
                        '  Corresponde a los estados Consolidados por cada paso Por Nodo Seleccionado. Durante el período y horario seleccionado',
                        '  Corresponde al downtime global del objetivo por paso, durante el período y horario seleccionado, en formato tabla',
                        '  Corresponde a la disponibilidad del objetivo durante el período y horario seleccionado',
                        '',
                        '', 
                        ' Corresponde al downtime global del objetivo, durante el período y horario seleccionado, en formato tabla'],
            Nodos: this.props.location.state.fromObjective.Nodos,
            extendView: this.props.extendView,
            periodicalView:periodicalView,
            intervalId: null,
            excelExportRows: null,
            excelExportFilename: ''
        };
    }

    componentWillUnmount() {
       clearInterval(this.state.intervalId);
    }
    
    tick() {
        if(this.state.checkedA===true){
            this.setState({
                date: new Date(),
                dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a")),
                isRefresh: true
            });
        }
    }

    handleDowntimeStepGeneralClick (){
        this.setState({
            typeGraph: 6,
            isForStep: true,
            isForNode: false,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: true,            
        });
    }

    handleDowntimeGeneralClick (){
        this.setState({
            typeGraph: 10,
            isForStep: false,
            isForNode: false,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: true,            
        });
    }

    handleAvailabilityGeneralClick() {
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        this.setState({
            typeGraph: 0,
            isForStep: false,
            isForNode: false,
            isLastEvent: false,
            nameNodo: t('availability.name-nodo'),
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: true,            
        });
    }

    handleAvailabilityLineClick() {
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        this.setState({
            typeGraph: 1,
            isForStep: false,
            isForNode: false,
            isLastEvent: false,
            nameNodo: t('availability.name-nodo'),
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: false,
            typePeriod: 4
        });
    }
    handleAvailabilityNodeClick() {
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        this.setState({
            typeGraph: 2,
            isForStep: false,
            isForNode: false,
            isLastEvent: false,
            nameNodo: t('availability.name-nodo'),
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: true,
        });
    }
    /*handleAvailabilityResponseClick() {
        this.setState({
            typeGraph: 3,
            isForStep: true,
            isForNode: false,
            isLastEvent: false,
            responseTimeGraphEl: null
        });
    }*/
    handleAvailabilityStepClick() {
        this.setState({
            typeGraph: 4,
            isForStep: false,
            isForNode: true,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: true,
        });
    }
    handleAvailabilityNodeDetailClick() {
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        this.setState({
            typeGraph: 5,
            isForStep: false,
            isForNode: false,
            isLastEvent: false,
            nameNodo: t('availability.name-nodo'),
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: true,
        });
    }
    handleAvailabilityConsolidatedClick() {
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        this.setState({
            typeGraph: 7,
            isForStep: false,
            isForNode: false,
            isLastEvent: false,
            nameNodo: t('availability.name-nodo'),
            responseTimeGraphEl: null,
            isRefresh: false,
            node: 0,
            nameStep: null,
            x2: null,
            x: null,
            y: null,
        });
    }
    handleAvailabilityConsolidatedPerStepClick() {
        let node = 0
        let nameNodo = null
        let isFull = false
        const {Nodos} = this.state
        Object.values(Nodos).map(i => { 
            if (i.id_nodo != 0 && !isFull){
                node = i.id_nodo
                isFull = true
                nameNodo = i.nodo
            }
        })

        this.setState({
            typeGraph: 8,
            isForStep: false,
            isForNode: true,
            isLastEvent: false,
            nameNodo: nameNodo,
            responseTimeGraphEl: null,
            isRefresh: false,
            node: node,
            nameStep: null,
            x2: null,
            x: null,
            y: null,
        });
    }

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (prevTypeGraph === 7 || prevTypeGraph === 8) {
            sessionStorage.setItem("availabilitySession",JSON.stringify({'nextPeriod':nextPeriod,'statePeriod':statePeriod}))
        }else if (prevTypeGraph === 6 || prevTypeGraph === 10){
            sessionStorage.setItem("availabilitySessionTable",JSON.stringify({'nextPeriod':nextPeriod,'statePeriod':statePeriod}))
        }else if (prevTypeGraph !== 7 || prevTypeGraph !== 8 || prevTypeGraph !== 10){
            sessionStorage.setItem("availabilitySessionTotal",JSON.stringify({'nextPeriod':nextPeriod,'statePeriod':statePeriod}))
        }
        
        if (nextPeriod === 'hora') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'hour').format("YYYY-MM-DD h:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 0,
                namePeriod: `${t('text.range')}: ${t('period.text.last-hour')}`,
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3hora') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(3,'hour').format("YYYY-MM-DD h:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                typeGraph: prevTypeGraph,
                period: '3h',
                typePeriod: 4,
                namePeriod: `${t('text.range')}: ${t('period.text.last-3-hours')}`,
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'dia') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'day').format("YYYY-MM-DD h:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 1,
                namePeriod: `${t('text.range')}: ${t('period.text.last-day')}`,
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3dia') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(3,'day').format("YYYY-MM-DD h:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                typeGraph: prevTypeGraph,
                period: "3d",
                typePeriod: 5,
                namePeriod: `${t('text.range')}: ${t('period.text.last-3-days')}`,
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'semana') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD h:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'week').format("YYYY-MM-DD h:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                typeGraph: prevTypeGraph,
                period: "w",
                typePeriod: 2,
                namePeriod: `${t('text.range')}: ${t('period.text.last-week')}`,
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'custom') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "c",
                typePeriod: 3,
                namePeriod: `${t('text.range')}: ${statePeriod.startDate.toISOString().substring(0, 10)} ${t('text.to2')} ${statePeriod.endDate.toISOString().substring(0, 10)}`,
                statePeriod: statePeriod,
                isStatePeriod: true,
                periodEl: null,
                isRefresh: false
            });
        }
        this.getDataFromAPI();
    }

    handleNextNodeClick = event => {
        const nameNodo = event.currentTarget.name
        const newNode = event.currentTarget.id
        if (this.state.node !== newNode) {
            this.setState({
                //typeGraph: prevTypeGraph,
                //period: prevPeriod,
                node: newNode,
                isLastEvent: false,
                extendEl: null,
                isRefresh: false,
                nameNodo: nameNodo,
            })
        }
    }
    handleNextStepClick = event => {
        const newSelectStep = event.currentTarget.name
        const newStep = event.currentTarget.id
        if (this.state.step !== newStep) {
            this.setState({
                //typeGraph: prevTypeGraph,
                //period: prevPeriod,
                step: newStep,
                isLastEvent: false,
                extendEl: null,
                nameSelectStep: newSelectStep,
                nameStep: newSelectStep
            })
        }
    }

    handleRefresh = event => {
        this.setState({
            isRefresh: true,
            settingsEl: null,
        })
    }

    handleInfo(props, step) {
        let oldDate = new Date(props.x)
        if (isNaN(oldDate)) {
            this.setState({
                nameStep: step,
                x: props.x,
                y: props.y
            })
        } else {
            
            let year = oldDate.getUTCFullYear()
            let month = oldDate.getUTCMonth()
            let day = oldDate.getUTCDate()
            let hours = oldDate.getUTCHours()
            let minutes = oldDate.getUTCMinutes()
            let seconds = oldDate.getUTCSeconds()

            let oldDateX2 = new Date(props.x2)
            let yearX2 = oldDateX2.getUTCFullYear()
            let monthX2 = oldDateX2.getUTCMonth()
            let dayX2 = oldDateX2.getUTCDate()
            let hoursX2 = oldDateX2.getUTCHours()
            let minutesX2 = oldDateX2.getUTCMinutes()
            let secondsX2 = oldDateX2.getUTCSeconds()

            let newDate = new Date(year, (month), day, hours, minutes, seconds)
            let newDateX2 = new Date(yearX2, (monthX2), dayX2, hoursX2, minutesX2, secondsX2)
            this.setState({
                nameStep: step,
                x: newDate.toLocaleString([], {hour12: false }),
                x2: newDateX2.toLocaleString([], {hour12: false }),
                y: props.y
            })
        }
    }
    handleDateMoment(props) {
        this.setState({
            dateMoment:props,
            isRefresh: false
        })
    }

    handleFirstInfo(props) {
        let oldDate = new Date(props.x)
        if (isNaN(oldDate)) {
            if (!this.state.isLastEvent && props.name !== null) {
                this.setState({
                    nameStep: props.name,
                    namePeriod: props.namePeriod,
                    x: props.x,
                    y: props.y,
                    isLastEvent: true
                })
            }
        } else {
            let year = oldDate.getUTCFullYear()
            let month = oldDate.getUTCMonth()
            let day = oldDate.getUTCDate()
            let hours = oldDate.getUTCHours()
            let minutes = oldDate.getUTCMinutes()
            let seconds = oldDate.getUTCSeconds()
            let newDate = new Date(year, (month), day, hours, minutes, seconds)
            if (!this.state.isLastEvent && props.name !== null) {
                this.setState({
                    nameStep: props.name,
                    x: newDate.toLocaleString([], {hour12: false }),
                    y: props.y,
                    namePeriod: props.namePeriod,
                    isLastEvent: true
                })
            }
        }
    }

    handleShowResponseTimeGraph = event => {
        this.setState({
            responseTimeGraphEl: event.currentTarget
        });
    };
    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };

    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    handleCloseResponseTimeGraph = () => {
        this.setState({
            responseTimeGraphEl: null
        });
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handleShowExtend = event => {
        this.setState({
            extendEl: event.currentTarget
        });
    };
    handleCloseExtend = () => {
        this.setState({
            extendEl: null
        });
    };
    handleChange = name=>event => {
        if (event.target.checked) {
            clearInterval(this.state.intervalId)
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({intervalId: newIntervalId})
        }
        this.setState({
            checkedA: event.target.checked 
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.automaticUpdate !== this.props.automaticUpdate && prevProps.refreshTime === this.props.refreshTime) {
            if (this.props.automaticUpdate) {
                clearInterval(this.state.intervalId)
                const newIntervalId = setInterval(
                    () => this.tick(),
                    this.props.refreshTime || REFRESH_TIME
                );
                this.setState({
                    intervalId: newIntervalId,
                    checkedA: this.props.automaticUpdate
                })
            } else {
                this.setState({checkedA: this.props.automaticUpdate})
                clearInterval(this.state.intervalId)
            }
        }
        if (prevProps.refreshTime !== this.props.refreshTime && this.state.checkedA) {
            clearInterval(this.state.intervalId)
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({
                intervalId: newIntervalId,
            })
        }
        if (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id || prevProps.extendView !== this.props.extendView) {
            this.onLayoutChange()
            this.setState({
                typeGraph: this.props.typeGraph,
                period: this.state.period,
                step: this.state.step,
                isForStep: false,
                nameStep: null,
                x: null,
                y: null,
                isLastEvent: false,
                objetive: this.props.match.params.objetivo_id,
                periodEl: null
            })
        }
        if (this.props.globalPeriodValue) {
            if (prevProps.globalPeriodValue !== this.props.globalPeriodValue ||
                (this.props.globalPeriodValue === "custom" &&
                this.props.globalStatePeriod.startDate !== prevProps.globalStatePeriod.startDate)
            ) {
                this.handlePeriodClick(null, this.state.typeGraph, this.props.globalStatePeriod, this.props.globalPeriodValue)
            }
        }
    }
    onLayoutChange = (e) => {  
        for (let i = 0; i < Highcharts.charts.length; i += 1) {
            if (Highcharts.charts[i] !== undefined) {
              Highcharts.charts[i].reflow(); // here is the magic to update charts' looking
            }
        }
    }
    componentDidMount() {
        if (this.props.automaticUpdate) {
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({intervalId: newIntervalId})
        }
        const {appliedToAllSelected, parseSelectedGlobalPeriod} = getDefaultPeriod()
        if (this.props.globalPeriodValue !== undefined && !this.props.periodical && !this.props.online && (appliedToAllSelected && parseSelectedGlobalPeriod)) {
            this.handlePeriodClick(null, this.state.typeGraph, parseSelectedGlobalPeriod.statePeriod, parseSelectedGlobalPeriod.value)
        } else {
            this.getDataFromAPI();
        }
    }
    getDataFromAPI=()=>{
        const {period, objetive, statePeriod, Nodos, typeGraph, node, nameNodo} = this.state;
        let token = sessionStorage.getItem('key')
        //var begin = statePeriod.startDate.toISOString().substring(0, 10)
        //var final = statePeriod.endDate.toISOString().substring(0, 10)   
        if (period == 'c'){
            var begin = statePeriod.startDate.toISOString().substring(0, 10)
            // var final = statePeriod.endDate.toISOString().substring(0, 10) 
            // correccion para que la fecha sea hora local
            var final = moment(statePeriod.endDate).format().substring(0, 10)  
        }else{
            var begin = statePeriod.startDate
            var final = statePeriod.endDate 
        }
        
        var getData = getMonitorsList(objetive, begin, final, token)           
        getData.then( data =>  { 
            var nodeBeta = node
            var nameNodoBeta = nameNodo
            var isFull = false
            if (typeGraph === 8){
                Object.values(data).map(i => { 
                    if (i.id_nodo != 0 && !isFull){
                        nodeBeta = i.id_nodo
                        isFull = true
                        nameNodoBeta = i.nodo
                    }
                })
            }
            this.setState({
                Nodos:data,
                node:nodeBeta,
                nameNodo:nameNodoBeta
            })
        })     
            
    }

    handleChangeSwitch = (event) => {
        const value = event.target.checked;
        this.setState({
            typeGraph: value ? 11 : 10,
            excelExportRows: null,
            excelExportFilename: ''
        })
    }

    handleExportDataReady = ({ excelRows, excelFilename }) => {
        this.setState({
            excelExportRows: excelRows,
            excelExportFilename: excelFilename
        })
    }

    render() {
        const t = this.props.t;
        const { classes, className, location } = this.props;
        const { typeGraph, period, isForStep, step, x2, x, y, nameStep, statePeriod, isStatePeriod, 
            namePeriod, node, isForNode, responseTimeGraphEl, periodEl, nameGraph,
            typePeriod, extendEl, settingsEl, isRefresh, isInfo, detalleGraph, date, dateMoment, nameNodo,
            scheduleName, nameSelectStep, isOneHour, periodical, Nodos, steps, periodicalView} = this.state;
        let buttonAvailabilityGeneral;
        let buttonAvailabilityLine;
        let buttonAvailabilityNode;
        //let buttonAvailabilityResponse;
        let buttonAvailabilityStep;
        let buttonAvailabilityNodeDetail;
        let buttonAvailabilityConsolidated;
        let buttonAvailabilityConsolidatedPerStep;
        const showExtendEl = Boolean(extendEl);
        const isForDowntimeGlobal = Boolean(typeGraph == 6);
        let buttonDowntimeGlobalStep= <AvailabilityDowntimeStepButton onClick={this.handleDowntimeStepGeneralClick} />
        let buttonDowntimeGlobal= <AvailabilityDowntimeButton onClick={this.handleDowntimeGeneralClick} />

        buttonAvailabilityGeneral = <AvailabilityGeneralButton onClick={this.handleAvailabilityGeneralClick} />;
        buttonAvailabilityLine = <AvailabilityLineButton onClick={this.handleAvailabilityLineClick} />;
        buttonAvailabilityNode = <AvailabilityNodeButton onClick={this.handleAvailabilityNodeClick} />;
        //buttonAvailabilityResponse = <AvailabilityResponseButton onClick={this.handleAvailabilityResponseClick} />;
        buttonAvailabilityStep = <AvailabilityStepButton onClick={this.handleAvailabilityStepClick} />;
        buttonAvailabilityNodeDetail = <AvailabilityNodeDetailButton onClick={this.handleAvailabilityNodeDetailClick} />;
        buttonAvailabilityConsolidated = <AvailabilityConsolidatedButton onClick={this.handleAvailabilityConsolidatedClick}/>;
        buttonAvailabilityConsolidatedPerStep = <AvailabilityConsolidatedPerStepButton onClick={this.handleAvailabilityConsolidatedPerStepClick}/>;

        const showResponseTimeGraphEl = Boolean(responseTimeGraphEl);
        const showSettingsEl = Boolean(settingsEl);
        const showIsInfo = Boolean(isInfo);
        const showPeriodEl = Boolean(periodEl);
        const rootClassName = classNames(classes.root, className);
        const divStyle = {
            top: '32%',left: '21%', width:'500px'
        };
        const divStylePop = {
            top: '57%',left: '48%'
        };
        let nameSelectStepRender = nameSelectStep

        if (typeGraph === 6 && nameSelectStep === 'Seleccione Paso'){
            nameSelectStepRender = location.state.fromObjective.Pasos[0].nombre_paso
            if(this.props.periodical===true && this.props.isStep===true){
                nameSelectStepRender=(steps.filter(i=>i.id_paso===step)[0]["nombre_paso"])
            }
        }

        const namePeriodPorlet = [t('period.text.last-hour'), t('period.text.last-day'), t('period.text.last-week'), t('period.text.custom'), t('period.text.last-3-hours'), t('period.text.last-3-days')]
        return (

            <Portlet
                    /*  {...rest} */
                    className={rootClassName}
                >
                    <PortletHeader className={classes.header}
                    >
                        <PortletLabel
                            /*  icon={<DevicesIcon />} */
                            variant="h6"
                            title={this.props.title + t(`availability.name-graph.${typeGraph}`)}
                        />

                        <PortletToolbar>
                            <IconButton
                                //className={classes.refreshButton}
                                //variant="text"
                                onClick={this.handleShowSettings}
                            >
                                <SettingsOutlinedIcon />
                                
                            </IconButton>
                            <Popover
                                    anchorEl={settingsEl}
                                    onClose={this.handleCloseSettings}
                                    open={showSettingsEl}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                      }}
                                      transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                      }}
                                    >
                                    <IconButton
                                        className={classes.refreshButton}
                                        variant="text"
                                        onClick={this.handleRefresh}
                                        onClose={this.handleCloseSettings}
                                    >
                                        <div>
                                            <RefreshIcon color="infoIcon" /><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>{t('text.update')}</Typography>
                                        </div>
                                    </IconButton>
                                    <IconButton
                                        onClick={this.handleShowIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                    >
                                        <div>
                                            <HelpIcon color="infoIcon"/><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>{t('availability.information.tooltip')}</Typography>
                                        </div>
                                    </IconButton>
                                     <Popover
                                        anchorEl={isInfo}
                                        open={showIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                        >
                                        <PortletContent variant="h4" style={{fontSize:'16px', color:'#66788A'}}>{t(`availability.details-graph.${typeGraph}`)}</PortletContent>
                                    </Popover>
                                    <Tooltip title={t('text.auto-update')}>
                                        <div style={{textAlign:"center"}}>
                                            <Switch
                                                checked={this.state.checkedA}
                                                onChange={this.handleChange('checkedA')}
                                                value="checkedA"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                color='primary'
                                            />
                                        </div>
                                    </Tooltip>
                                </Popover>                            
                          
                                { typeGraph === 9 || typeGraph === 6 || typeGraph === 10 || typeGraph === 11 ?
                                        null
                                    : 
                                    <Button
                                        style={{color:"#353535"}}
                                        variant="text"
                                        onClick={this.handleShowResponseTimeGraph}
                                        >
                                            {t('availability.text.graphs')} <ArrowRightIcon />
                                    </Button>                                 
                                } 
                            {/* Popover para mostrar la seleccion de graficos, segun distribucion*/}
                            <Popover
                                anchorEl={responseTimeGraphEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center'
                                }}
                                onClose={this.handleCloseResponseTimeGraph}
                                open={showResponseTimeGraphEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center'
                                }}>
                                
                                {typeGraph == 7 ?
                                        <div>
                                            {buttonAvailabilityConsolidated}<br />
                                            {buttonAvailabilityConsolidatedPerStep}<br />
                                        </div>
                                    :typeGraph===10 || typeGraph===11?
                                        <div>
                                            {buttonDowntimeGlobalStep}<br />
                                        </div>
                                    : typeGraph == 8 ?
                                        <div>
                                            {buttonAvailabilityConsolidated}<br />
                                            {buttonAvailabilityConsolidatedPerStep}<br />
                                        </div>
                                    : typeGraph == 6 ?
                                        <div>
                                            {buttonDowntimeGlobal}
                                        </div>
                                    :    <div style={{textAlign:"left"}}>
                                            {buttonAvailabilityGeneral}<br />
                                            {buttonAvailabilityLine}<br />
                                            {buttonAvailabilityNode}<br />
                                            {/*{buttonAvailabilityResponse}*/}
                                            {buttonAvailabilityNodeDetail}<br />
                                            {buttonAvailabilityStep}<br />
                                        </div>
                                    }                                 
                               
                            </Popover>
                        </PortletToolbar>
                    </PortletHeader>
                    <PortletContent className={classes.content}>
                        <Grid
                            container
                            spacing={10}
                        >
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}>
                                <PerfectScrollbar>
                                   
                                <div >
                                {period == 'c' ?
                                            <div >
                                                <Typography   color="textSecondary" gutterBottom>
                                                    {t('text.from')} {statePeriod.startDate.toISOString().substring(0, 10)} {t('text.to')} {moment(statePeriod.endDate).format().substring(0, 10)}
                                                </Typography>
                                                {periodical?
                                                <Typography   color="textSecondary" gutterBottom>
                                                    {t('availability.text.schedule')} {scheduleName}
                                                </Typography>
                                                :null
                                                }
                                            </div>
                                            
                                        : null}
                                    {typeGraph === 11 || typeGraph === 10 ?
                                        <Box display='flex' alignItems='center' justifyContent='flex-end'>
                                            <AvailabilityDowntimeGlobalWithErrorSwitch handleChangeSwitch={this.handleChangeSwitch} typeGraph={typeGraph} />
                                            <TableExcelExportButton rows={this.state.excelExportRows} filename={this.state.excelExportFilename} />
                                        </Box>
                                    : null}
                                    {<Graph
                                        typeGraph={typeGraph}
                                        period={period}
                                        step={step}
                                        node={node}
                                        onInfo={this.handleInfo}
                                        onFirstInfo={this.handleFirstInfo}
                                        statePeriod={statePeriod}
                                        isStatePeriod={isStatePeriod}
                                        isRefresh={isRefresh} 
                                        date={date}
                                        onDateMoment={this.handleDateMoment}
                                        schedule={this.state.schedule}
                                        name={t(`availability.name-graph.${typeGraph}`)}
                                        periodical={periodical}
                                        periodicalView={periodicalView}
                                        nameStep={nameStep}
                                        objetivo_id={this.props.match.params.objetivo_id}
                                        intervalId={this.state.intervalId}
                                        refreshTime={this.props.refreshTime || REFRESH_TIME}
                                        onExportDataReady={this.handleExportDataReady}
                                        objectiveName={buildObjectiveTitle(this.props.location.state.fromObjective)}
                                        />}
                                        
                                </div>
                                <div>
                                    { typeGraph == 7 ?
                                        <div>
                                            <Typography  style={{fontSize:'13px',float:'left', paddingLeft:'5px', color:'#66788A'}}>
                                                {/*<h5>{namePeriod}</h5>*/}
                                                <h3>{y}</h3>
                                                <h1>{nameStep}</h1>
                                                <h5>{x} -</h5>
                                                <h5>{x2}</h5>
                                            </Typography>
                                        </div>
                                    :typeGraph == 10 ?
                                    <div>
                                    </div>
                                    : typeGraph == 8 ?
                                        <div>
                                            <Typography  style={{fontSize:'13px',float:'left', paddingLeft:'5px', color:'#66788A'}}>
                                                {/*<h5>{namePeriod}</h5>*/}
                                                <h3>{y}</h3>
                                                <h1>{nameStep}</h1>
                                                <h5>{x} -</h5>
                                                <h5>{x2}</h5>
                                            </Typography>
                                        </div>
                                    : typeGraph != 6 ?
                                        periodical?
                                        null:

                                            <div>
                                                <Typography  style={{fontSize:'13px',float:'left', paddingLeft:'5px', color:'#66788A'}}>
                                                    {/*<h5>{namePeriod}</h5>*/}
                                                    <h5>{nameStep}</h5>
                                                    <h1>{y}(%)</h1>
                                                    <h5>{x}</h5>
                                                </Typography>
                                            </div>
                                    : null}
                                    {periodical?null:
                                        <div style={{float:"right", marginTop:"5%"}}>
                                            <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }}>
                                                {/* <Typography >
                                            Última actualización:
                                            </Typography> */}
                                                
                                                <Avatar variant="rounded" className={classes.rounded}>
                                                <UpdateIcon /> 
                                                </Avatar>
                                                <Typography  className={classes.updateTime}   >
                                                    &nbsp; {t('text.last-update')}: {dateMoment} 
                                                </Typography>
                                                
                                            </div>
                                        </div>
                                    }
                                    
                                </div>                            
                                </PerfectScrollbar>
                            </Grid>
                        </Grid>
                        
                    </PortletContent>
                    
                    <PortletFooter className={classes.portletFooter}>
                        <Button  style={{fontSize:'15px',float:'left', color:'#66788A'}} onClick={this.handleShowPeriod}>
                            {namePeriodPorlet[typePeriod]}<ArrowDropDownIcon />
                        </Button>
                        <Popover
                            anchorEl={periodEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            onClose={this.handleClosePeriod}
                            open={showPeriodEl}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}>
                            <Period onClick={this.handlePeriodClick} range={statePeriod} period={period} periodical={periodical} typeGraph={typeGraph} isOneHour={isOneHour}/>
                        </Popover>
                        { isForNode ?
                            <div>
                                <Button
                                    color="primary"
                                    variant="text"
                                    onClick={this.handleShowExtend}
                                >
                                    {nameNodo} <ArrowRightIcon />
                                </Button>
                                
                                <Popover
                                    anchorEl={extendEl}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center'
                                    }}
                                    onClose={this.handleCloseExtend}
                                    open={showExtendEl}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center'
                                    }}>
                                    <div >
                                        {isForNode ? <div className="row1">
                                                        <List component="div">
                                                            {Object.values(Nodos).map(i => (
                                                                
                                                                <ListItem
                                                                    className={classes.listItem}
                                                                    component="div"
                                                                >
                                                                {typeGraph == 8 && i.nodo == 'Global' ?
                                                                    null
                                                                :
                                                                    <Button id={i.id_nodo} name={i.nodo} onClick={(event) => this.handleNextNodeClick(event)}>{i.nodo}</Button> 
                                                                }
                                                                </ListItem>))}
                                                        </List>
                                                    </div> 
                                            : 
                                                    <div>{t('availability.text.no-information-to-show')}</div>
                                        }
                                    </div>
                                </Popover> 
                            </div> 
                        : isForStep?
                            <div>
                                <Button
                                    color="primary"
                                    variant="text"
                                    onClick={this.handleShowExtend}
                                >
                                    {nameSelectStepRender}
                                    <ArrowRightIcon />
                                </Button>
                                <Popover
                                    anchorEl={extendEl}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center'
                                    }}
                                    onClose={this.handleCloseExtend}
                                    open={showExtendEl}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center'
                                    }}>
                                    <div >
                                        {isForDowntimeGlobal ? <div className="row1">
                                                        <List component="div">
                                                            {Object.values(location.state.fromObjective.Pasos).map(i => (
                                                                <ListItem
                                                                    className={classes.listItem}
                                                                    component="div"
                                                                >
                                                                <Button id={i.id_paso} name={i.nombre_paso} onClick={(event) => this.handleNextStepClick(event)}>{i.nombre_paso}</Button> 
                                                                </ListItem>))}
                                                        </List>
                                                    </div> : <div>{t('availability.text.no-information-to-show')}</div>}
                                    </div>
                                </Popover>
                            </div>
                        : 
                            null
                        
                        }
                        
                    </PortletFooter>
                </Portlet>
        )
    }
}

function Graph(props) {
    //console.log("paso index=>", props.step)
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {    
        return <AvailabilityGeneral params={props} />;
    }
    if (typeGraph === 1) {
        return <AvailabilityLine params={props} />;
    }
    if (typeGraph === 2) {
        return <NewGraphAvailabilityNode
            objetivoId={props.objetivo_id}
            globalStatePeriod={props.statePeriod}
            time={props.period}
            horarioId={props.schedule}
        />;
    }
    /*
    if (typeGraph === 3) {
        return <AvailabilityResponse params={props} />;
    }*/
    if (typeGraph === 4) {
        return <AvailabilityStep params={props} />;
    }
    if (typeGraph === 5) {
        return <AvailabilityNodeDetail params={props} />;
    }
    if (typeGraph === 6) {
        return <AvailabilityDowntimeGlobal params={props} />;
    }
    if (typeGraph === 7) {
        //console.log('envio a grafico', props)
        return <AvailabilityConsolidated params={props} />;
    }
    if (typeGraph === 8) {
        return <AvailabilityConsolidatedPerStep params={props} />;
    }
    if (typeGraph === 9) {
        return <TableAvailability params={props} />;
    }
    if (typeGraph === 10) {
        return <AvailabilityDowntime params={props} />;
    }
    if (typeGraph === 11) {
        return <AvailabilityDowntimeGlobalWithError
            objetivoId={props.objetivo_id}
            period={props.period}
            statePeriod={props.statePeriod}
            refreshTime={props.intervalId ? props.refreshTime : false}
            onExportDataReady={props.onExportDataReady}
            objectiveName={props.objectiveName}
        />
    }
}

function AvailabilityDowntimeButton(props) {
    return (
        <Button onClick={props.onClick}>
            Downtime Consolidado Global
      </Button>
    );
}

function AvailabilityDowntimeStepButton(props) {
    const { t } = useTranslation();
    return (
        <Button onClick={props.onClick}>
            {t('availability.buttons.consolidated-downtime-global-by-step')}
      </Button>
    );
}

function AvailabilityGeneralButton(props) {
    const tab = <>&nbsp;</>;
    const { t } = useTranslation();
    return (
        <Button onClick={props.onClick}>
            {t('availability.buttons.general')}{tab}
      </Button>
    );
}

function AvailabilityLineButton(props) {
    const { t } = useTranslation();
    const tab = <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>;
    return (
        <Button onClick={props.onClick}>
            {t('availability.buttons.line')}{tab}
      </Button>
    );
}

function AvailabilityNodeButton(props) {
    const { t } = useTranslation();
    const tab = <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>;
    return (
        <Button onClick={props.onClick}>
            {t('availability.buttons.node')}{tab}
      </Button>
    );
}
/*
function AvailabilityResponseButton(props) {
    return (
        <Button onClick={props.onClick} >
            Comparativo
      </Button>
    );
}
*/
function AvailabilityStepButton(props) {
    const { t } = useTranslation();
    return (
        <Button onClick={props.onClick}>
            {t('availability.buttons.percentage')}
      </Button>
    );
}

function AvailabilityNodeDetailButton(props) {
    const { t } = useTranslation();
    return (
        <Button onClick={props.onClick}>
            {t('availability.buttons.steps')}
      </Button>
    );
}

function AvailabilityConsolidatedButton(props) {
    const { t } = useTranslation();
    return (
        <Button onClick={props.onClick}>
            {t('availability.buttons.consolidated')}
      </Button>
    );
}

function AvailabilityConsolidatedPerStepButton(props) {
    const { t } = useTranslation();
    return (
        <Button onClick={props.onClick}>
            {t('availability.buttons.consolidated-per-step')}
      </Button>
    );
}

function AvailabilityDowntimeGlobalWithErrorSwitch(props) {
    const { t } = useTranslation();
    return (
        <FormControlLabel
            control={
                <Switch onChange={props.handleChangeSwitch} checked={props.typeGraph === 11} color='primary' />
            }
            label={t('availability-downtime.with-error')}
        />
    )
}

export default
    compose(withRouter, withStyles(styles), withTranslation())(Availability);